/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * BFF API
 * OpenAPI spec version: 1.0
 */

/**
 * Whether the window makes the vehicle available or blocks it.
 */
export type AvailabilityDtoType = typeof AvailabilityDtoType[keyof typeof AvailabilityDtoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AvailabilityDtoType = {
  AVAILABLE: 'AVAILABLE',
  BLOCKED: 'BLOCKED',
} as const;
